/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_rejected_medium'
export default icon
